import { AppState } from '../../init/rootReducer';
import { makeQueryKey } from './helpers';
import { LoginAsState } from './reducers/pageReducer';
import { initialQueryState, LoginAsQueryState } from './reducers/queryReducer';

export const getLoginAsPageState = (state: AppState): LoginAsState => state.containers.loginAs;

export const getLoginAsQueryState = (state: AppState, search: string): LoginAsQueryState =>
  getLoginAsPageState(state).queries[makeQueryKey(search)] || initialQueryState;
